export const RISK_DETAIL_SUBTITLE = 'Clique em cada item para ver detalhes e recomendações';
export const QA_SUBTITLE = 'Usamos este contrato como contexto';
export const PARTIES_SUBTITLE = 'Informações das partes envolvidas no contrato';
export const RISK_DISCLAIMER = 'Esta análise é baseada em inteligência artificial e serve como orientação. Consulte um advogado para questões jurídicas específicas.';
